import React, { useState, useRef } from "react";
import { useDraggable } from "@progress/kendo-react-common";
import styles from "../CaseWorkflow.module.scss";
import Picker from "../../../../assets/picker.png";

const DraggableFieldType = ({ fieldType, onDragStart }) => {
  const itemRef = useRef(null);
  const hintRef = useRef(null);
  const [position, setPosition] = useState(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);

  const fieldDisplayNames = {
    Label: "Label",
    Text: "Text Box",
    Combobox: "Combo Box",
    Dropdown: "Drop down",
    Date: "Date",
    MultilineText: "Multiline Text",
    Integer: "Number",
    Decimal: "Decimal",
    Time: "Time",
    DateTime: "Date Time",
    CheckBox: "Check Box",
    Radio: "Radio Button",
  };

  const handlePress = (event) => {
    setOffset({ x: event.offsetX, y: event.offsetY });
  };

  const handleDragStart = () => {
    setIsDragging(true);
    onDragStart(fieldType);
  };

  const handleDrag = (event) => {
    setPosition({
      x: event.clientX - offset.x,
      y: event.clientY - offset.y,
    });
  };

  const handleDragEnd = () => {
    setIsDragging(false);
    setPosition(null);
    setOffset({ x: 0, y: 0 });
  };

  useDraggable(
    itemRef,
    {
      onPress: handlePress,
      onDragStart: handleDragStart,
      onDrag: handleDrag,
      onDragEnd: handleDragEnd,
    },
    { hint: hintRef, autoScroll: false }
  );

  return (
    <div
      ref={itemRef}
      className={`${styles.draggableField} ${
        isDragging ? styles.dragging : ""
      }`}
      onMouseDown={(e) => e.preventDefault()}
    >
      <img src={Picker} alt="drag handle" className={styles.dragHandle} />
      <span className={styles.fieldName}>
        {fieldDisplayNames[fieldType] || fieldType}
      </span>

      {position && (
        <div
          ref={hintRef}
          className={styles.dragHint}
          style={{
            left: position.x,
            top: position.y,
          }}
        >
          <img src={Picker} alt="drag handle" className={styles.hintImage} />
          <span className={styles.hintText}>
            {fieldDisplayNames[fieldType] || fieldType}
          </span>
        </div>
      )}
    </div>
  );
};

export default DraggableFieldType;
